import About from './component/About';
import Contact from './component/Contact';
import Projects from './component/Projects';
import Resume from './component/Resume';
import Skill from './component/Skill';
import Header from './component/Header';
function App()
{
  return(
    <div>
      <Header />
      <About />
      <Contact />
      <Projects />
      <Resume />
      <Skill />
    </div>
  );
}export default App;